exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Careers{padding-top:60px;padding-bottom:60px;background-color:#e5f6fd}.Careers__title{font-weight:700;font-size:2.8rem;font-family:Oswald,serif;letter-spacing:.1rem;text-align:center;margin-bottom:30px}@media screen and (max-width:767px){.Careers__title{margin-bottom:20px}}.Careers a:active,.Careers a:hover,.Careers a:link,.Careers a:visited{color:#2d5da5}@media screen and (max-width:767px){.Careers{padding-top:40px;padding-bottom:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../src/components/careers/index.scss
// module id = 884
// module chunks = 0